import angular from 'angular';
import URLS from 'Helpers/urls';
import UTILS from 'Helpers/util';

(function () {
    'use strict';

    angular.module('app').component('homepage', {
        template: require('./home-page.html'),
        controller: HomePageCtrl,
        controllerAs: 'vm'
    });

    HomePageCtrl.$inject = [
        '$scope',
        '$state',
        '$rootScope',
        '$stateParams',
        '$location',
        'ModalService',
        'QueryService',
        'SessionService',
        'logger'
    ];

    function HomePageCtrl(
        $scope,
        $state,
        $rootScope,
        $stateParams,
        $location,
        ModalService,
        QueryService,
        SessionService,
        logger
    ) {
        var vm = this;
        vm.version = UTILS.version;

        vm.mainBackground = require('Images/background.png');
        vm.logo = require('Images/nav-logo.png');

        vm.img_rating = require('Images/SSP/rating.png');
        vm.img_change_schedule = require('Images/SSP/change_schedule.png');
        vm.img_complaint = require('Images/SSP/complaint.png');
        vm.img_question = require('Images/SSP/question.png');
        vm.img_receipt = require('Images/SSP/receipt.png');
        vm.img_contact_us = require('Images/SSP/contact_us.png');
        vm.img_inquiry = require('Images/SSP/inquiry.png');

        vm.id = $stateParams.id;

        vm.redirectMe = function(route, query) {
            if(query){
                $location.path(route).search({mode: query, id: vm.id});
            }else{
                $location.path(route);
            }
        }

        vm.get_data = function(){
            
            var request = {
                method: 'GET',
                route: URLS.base + `/regular_class_item/${vm.id}/regular_class`,
            };

            
            QueryService.query(request)
                .then(
                    function(response) {
                        vm.submitted = true;
                        vm.item = response.data.data.data[0].id;
                        // console.log(response.data.data.data[0].id);
                        if(!vm.item){
                            vm.id = null;

                        }

                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });
        }

        vm.get_data();


    }
})();



// WEBPACK FOOTER //
// ./src/app/components/home-page/home-page.component.js